import $ from "jquery";
import deps from "../dependencies";

const Flickity = deps.flickity;

// Debug log to check if Flickity is available
// console.debug("Flickity available:", !!Flickity);

// Function to handle focusable elements
function handleFocusableElements($slider, index) {
    const $slides = $slider.find(".flickity-slider > *");

    $slides.each((i, slide) => {
        const $slide = $(slide);
        if (i === index) {
            $slide.attr("tabindex", "0");
        } else {
            $slide.attr("tabindex", "-1");
        }
    });
}

// Handle drag events
$(".sb_featured-section_items").on("dragStart.flickity", (event) => {
    $(event.currentTarget).addClass("s_is-dragging");
});

$(".sb_featured-section_items").on("dragEnd.flickity", (event) => {
    $(event.currentTarget).removeClass("s_is-dragging");
});

// Handle slide selection
$(".sb_featured-section_items").on("select.flickity", (event, index) => {
    handleFocusableElements($(event.currentTarget), index);
});

// Initialize Flickity instances
function initializeFlickity() {
    $(".sb_featured-section_items").each((i, element) => {
        const $element = $(element);
        const flkty = Flickity.data(element);

        if (flkty) {
            handleFocusableElements($element, flkty.selectedIndex);
        } else {
            // Try again after a short delay
            setTimeout(() => {
                const retryFlkty = Flickity.data(element);
                if (retryFlkty) {
                    handleFocusableElements($element, retryFlkty.selectedIndex);
                }
            }, 100);
        }
    });
}

// Run initialization after a short delay to ensure Flickity is ready
setTimeout(initializeFlickity, 100);

// Also run initialization when the window loads
$(window).on("load", initializeFlickity);

// Flickity breekt de pointerdown af en focust daarna zelf de root, en browsers tellen dat als
// toetsenbordfocus: :focus-visible tekende de ring dus bij elke sleep. Focus die van een pointer
// komt krijgt `data-pointer-focus` (zie _a11y.scss); een toets of het verlaten van de slider haalt
// hem weg, zodat toetsenbordgebruikers de ring houden.
document.addEventListener(
    "pointerdown",
    (event) => {
        const slider = event.target.closest(".flickity-enabled");
        if (slider) {
            slider.dataset.pointerFocus = "";
        }
    },
    true
);

document.addEventListener(
    "keydown",
    () => {
        const active = document.activeElement;
        if (active && active.dataset && "pointerFocus" in active.dataset) {
            delete active.dataset.pointerFocus;
        }
    },
    true
);

document.addEventListener(
    "focusout",
    (event) => {
        if (event.target.dataset && "pointerFocus" in event.target.dataset) {
            delete event.target.dataset.pointerFocus;
        }
    },
    true
);
